<div class="cc-community-search-component-container">
    <dx-text-box
        class="cc-search-text-input"
        [placeholder]="placeholder"
        [ngClass]="searchTextClass"
        [stylingMode]="'underlined'"
        [showClearButton]="true"
        [readOnly]="!!disableSearchText"
        [(value)]="searchText"
        (onEnterKey)="searchCommunities()"
    >
        <dxi-button name="searchAfter" location="after" [options]="searchButton"></dxi-button>
        <dxi-button name="clear" location="after"></dxi-button>
    </dx-text-box>
    <dx-button
        *ngIf="loading"
        icon="fas fa-spinner fa-pulse"
        class="cc-search-button cc-dummy-button"
        stylingMode="text"
    ></dx-button>
</div>

<dx-popup
    #communityPopup
    title="Matching Community"
    [minWidth]="isSmallScreen ? popupWidth : undefined"
    [minHeight]="isSmallScreen ? popupHeight : undefined"
    [maxWidth]="!isSmallScreen ? popupWidth : undefined"
    [maxHeight]="!isSmallScreen ? popupHeight : undefined"
    [showTitle]="true"
    [dragEnabled]="true"
    [deferRendering]="true"
    [showCloseButton]="true"
    [visible]="popupVisible"
    (onHiding)="hide()"
    (onShown)="populateCommunities()"
>
    <app-search-community
        #searchCommunity
        [isQuickSearch]="true"
        [searchText]="searchText"
        (saveLastSearchResult)="saveLastSearchResult($event)"
        (onCommunitySelect)="onCommunitySelect($event)"
    ></app-search-community>
</dx-popup>
